module.exports = __webpack_public_path__ + "static/ey-4-1adef078ac50b08072bb069b51331148.png";